export function getQueryParam(param: string): string | undefined {
  const params = new URLSearchParams(window.location.search);
  return params.get(param) ?? undefined;
}

export function queryParamsString(dict: Record<string, string>) {
  return new URLSearchParams(dict).toString();
}
